export default __webpack_public_path__ + "media/images/portfolio/gallery-03-370x220-04949576525ba1beee07d48b24eda10e.jpg";